const BASE_LINES = [
    '[    0.000000] Booting Khwahish Portfolio OS (x86_64)',
    '[    0.000001] Initializing backend-optimized scheduler',
    '[    0.000012] Memory regions mapped successfully',
    '[    0.000021] Mounting virtual portfolio filesystem',
    '[    0.000033] Loading API, DB, and cloud modules',
];

const facilities = [
    'kernel',
    'systemd[1]',
    'networkd',
    'portfoliod',
    'scheduler',
];

const subsystems = [
    'vfs',
    'tls',
    'http',
    'db',
    'cache',
    'queue',
    'auth',
];

const actions = [
    'initializing',
    'attaching',
    'configuring',
    'warming cache for',
    'verifying integrity of',
    'registering',
];

export function generateKernelLines(count = 320) {
    const lines = [...BASE_LINES];

    for (let i = lines.length; i < count; i++) {
        const ts = (0.001 + i * 0.00007).toFixed(6);
        const fac = facilities[i % facilities.length];
        const sub = subsystems[i % subsystems.length];
        const act = actions[i % actions.length];

        lines.push(
            `[    ${ts}] ${fac}: ${act} ${sub} subsystem [OK]`
        );
    }

    lines.push('[    2.999999] System ready.');
    return lines;
}
